<template>
    <header class="py-10">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <nav class="relative z-50 flex justify-between">
                <div class="flex items-center md:gap-x-12">
                    <router-link :to="{name: 'role'}" class="mr-16"><IconLogo/></router-link>
                    <div class="hidden md:flex md:gap-x-6"></div>
                </div>
                <div class="flex items-center gap-x-5 md:gap-x-8"></div>
            </nav>
        </div>
    </header>

    <main>
        <div class="absolute top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-16 pt-16 text-center w-full">
            <h1 class="mx-auto max-w-4xl font-display text-5xl font-medium tracking-tight text-slate-900 sm:text-7xl">404</h1>
            <p class="mx-auto mt-4 max-w-2xl text-lg tracking-tight text-slate-700">Упс! Кажется, мы не можем найти страницу, которую вы искали.</p>
            <div class="mt-8 flex justify-center gap-x-6">
                <router-link :to="{name: 'role'}" class="w-[20rem] cursor-pointer bg-custom-blue hover:bg-custom-blue-hover text-center text-white font-medium rounded-lg text-sm px-5 py-2 mb-8">На главную страницу</router-link>
            </div>
        </div>
    </main>
</template>

<script>
    import IconLogo from '@/components/Icon/IconLogo.vue';

    export default {
        name: "PageNotFound",
        components: {
            IconLogo,
        }
    }
</script>